import { colors } from '../../colors';
var address = {
  arrowColor: colors.tomatoRed,
  textColor: colors.ash,
  borderColor: colors.ash,
  backgroundColor: colors.white
};
export default address;